import { useEffect } from "react";
import { InputBox } from "@/components/ui/InputBox";
import { CheckBox } from "@/components/ui/CheckBox";
import { Button } from "@/components/ui/Button";
import { FieldErrors, FieldValues, useForm } from "react-hook-form";
import { toast } from "@/lib/toast";
import { printDeveloperInfo } from "@/lib/console";
import { useLogin } from "@/hooks/member/useMember";
import { useSearchParams } from "react-router-dom";

export default function LoginPage() {
  const { register, handleSubmit } = useForm();
  const [searchParams] = useSearchParams();

  // 이스터에그: 개발자 정보
  useEffect(() => {
    printDeveloperInfo();
  }, []);

  // 🔐 Java 백엔드 로그인 훅 사용
  const loginMutation = useLogin({ redirectUrl: "/additional/memo" }); // 메인인 메모 페이지로 리다이렉트

  const loginHandler = (data: FieldValues) => {
    console.log("🚀 로그인 시도:", data);

    loginMutation.mutate({
      name: data.userName,
      password: data.userPw,
    });
  };

  const onInvalidSubmit = (errors: FieldErrors) => {
    // 첫 번째 에러만 toast로 표시
    const firstError = Object.values(errors)[0] as any;
    if (firstError?.message) {
      toast.error(firstError.message);
    }
  };

  return (
    <>
      <div className="flex flex-row w-full h-screen">
        <div className="w-1/3 h-screen relative">
          <img src="/images/loginBack.svg" alt="logo" className="w-full h-full object-cover object-left" />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white z-10 text-center">
            <span className="text-white text-3xl font-light leading-tight">SPECIAL PARTNER</span>
            <br />
            <span className="text-white text-6xl font-black leading-none">JUNG AM</span>
            <br />
            <span className="text-white text-6xl leading-tight">LOGISTICS</span>
          </div>
        </div>
        <div className="w-2/3 h-full">
          <div className="flex flex-col items-center justify-center h-full">
            <img src="/images/titleFullLogo.svg" alt="titleLogo" width={280} height={60} />
            <div className="mb-9" />
            <form onSubmit={handleSubmit(loginHandler, onInvalidSubmit)}>
              <div>
                <InputBox
                  {...register("userName", {
                    required: "이름을 입력해주세요.",
                    minLength: {
                      value: 2,
                      message: "이름은 최소 2자 이상 입력해주세요.",
                    },
                    maxLength: {
                      value: 20,
                      message: "이름은 최대 20자까지 입력 가능합니다.",
                    },
                  })}
                  autoComplete="username"
                  className="
                  w-[392px]
                  border border-[#CCC]
                  rounded-lg
                  px-4
                  py-5
                  text-lg
                  placeholder:text-[#CCC]
                  placeholder:text-xl"
                  placeholder="이름"
                />
              </div>
              <div className="mb-5" />
              <div>
                <InputBox
                  {...register("userPw", {
                    required: "비밀번호를 입력해주세요.",
                    minLength: {
                      value: 4,
                      message: "비밀번호는 최소 4자 이상 입력해주세요.",
                    },
                    maxLength: {
                      value: 30,
                      message: "비밀번호는 최대 30자까지 입력 가능합니다.",
                    },
                  })}
                  type="password"
                  autoComplete="current-password"
                  className="
                  w-[392px]
                  border border-[#CCC]
                  rounded-lg
                  px-4
                  py-5
                  text-lg
                  placeholder:text-[#CCC]
                  placeholder:text-xl"
                  placeholder="비밀번호"
                />
              </div>
              <div className="mb-5" />

              <div className="w-[392px] flex justify-start">
                <CheckBox {...register("rememberMe")} label="로그인 상태 유지" />
              </div>

              <div className="mb-5" />

              <Button id="loginBtn" type="submit" className="w-[392px] py-5" disabled={loginMutation.isPending}>
                {loginMutation.isPending ? "로그인 중..." : "로그인"}
              </Button>
            </form>

            <div className="mb-[30px]" />
            <span className="font-medium text-[#898989]">© 2025 Jung Am Logistics, Inc.</span>
          </div>
        </div>
      </div>
    </>
  );
}
